import React from "react";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import moment from "moment";

const ContractCalculations = ({
  contractInstallments,
  currentContract,
  originalContractTotal,
  interestMarketTotal,
  overchargedAmountTotal,
  paidTotal,
  overpaidAmountTotal,
  isOverpaid,
  captionCalcOverpaidAmountTotal,
  captionOverpaidAmoutTotal,
  captionLegalInterestToptal,
  legalInterestTotal,
  captionIgpmTotal,
  igpmTotal,
  captionCalcReturnTotal,
  captionReturnTotal,
  returnTotal,
}) => {
  return (
    <>
      <Table size="small" sx={{ minWidth: 1800 }}>
        <TableHead sx={{ backgroundColor: "#f0f0f0" }}>
          <TableRow>
            <TableCell align="center" colspan={7} sx={{ fontWeight: "bold", borderRight: '2px solid #000', borderTop: '2px solid #000', borderLeft: '2px solid #000', borderBottom: '2px solid #000' }}>CÁLCULO VALOR COM TAXA DE MERCADO</TableCell>
            <TableCell sx={{ width: '5px', backgroundColor: "#ffffff" }}></TableCell>
            <TableCell align="center" colspan={6} sx={{ fontWeight: "bold", borderRight: '2px solid #000', borderTop: '2px solid #000', borderLeft: '2px solid #000', borderBottom: '2px solid #000' }}>CORREÇÃO DO VALOR PAGO A MAIOR</TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="center" sx={{ fontWeight: "bold", borderLeft: '2px solid #000' }}>PARCELA</TableCell>
            <TableCell align="center" sx={{ fontWeight: "bold" }}>DATA DO PAGAMENTO</TableCell>
            <TableCell align="right" sx={{ fontWeight: "bold" }}>VALOR DEVIDO</TableCell>
            <TableCell align="right" sx={{ fontWeight: "bold" }}>JUROS</TableCell>
            <TableCell align="right" sx={{ fontWeight: "bold" }}>SALDO ATUAL</TableCell>
            <TableCell align="right" sx={{ fontWeight: "bold" }}>AMORTIZAÇÃO</TableCell>
            <TableCell align="right" sx={{ fontWeight: "bold", borderRight: '2px solid #000' }}>PARCELA</TableCell>
            <TableCell sx={{ width: '5px', backgroundColor: "#ffffff" }}></TableCell>
            <TableCell align="center" sx={{ fontWeight: "bold", borderLeft: '2px solid #000' }}>VALOR PAGO/COBRADO A MAIOR</TableCell>
            <TableCell align="center" sx={{ fontWeight: "bold" }}>JUROS 1% A.M. ACUMULADO</TableCell>
            <TableCell align="right" sx={{ fontWeight: "bold" }}>JUROS LEGAIS</TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>ÍNDICE CORREÇÃO IGP-M</TableCell>
            <TableCell align="right" sx={{ fontWeight: "bold" }}>VALOR IGPM</TableCell>
            <TableCell align="right" sx={{ fontWeight: "bold", borderRight: '2px solid #000' }}>TOTAL CORREÇÃO</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {contractInstallments.map((item, index) => (
            <TableRow sx={{ height: 10 }} key={index}>
              <TableCell align="center" sx={{ borderLeft: '2px solid #000' }}>{item.installment_number}</TableCell>
              <TableCell align="center">{moment(item.payment_at).format("DD/MM/YYYY")}</TableCell>
              <TableCell align="right" >{item.amount_due.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</TableCell>
              <TableCell align="right" >{item.interest_value.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</TableCell>
              <TableCell align="right" >{item.current_balance.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</TableCell>
              <TableCell align="right" >{item.amortization.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</TableCell>
              <TableCell align="right" sx={{ backgroundColor: "#f0f0f0", borderRight: '2px solid #000' }}>{item.installment_value.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</TableCell>
              <TableCell sx={{ width: '5px', backgroundColor: "#ffffff" }}></TableCell>
              <TableCell align="right" sx={{ borderLeft: '2px solid #000' }}>{item.overpaid_value.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</TableCell>
              <TableCell align="center" >{item.interest_monthly.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</TableCell>
              <TableCell align="right" >{item.legal_interest.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</TableCell>
              <TableCell align="right" >{item.igpm_correction_index.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</TableCell>
              <TableCell align="right" >{item.igpm_value.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</TableCell>
              <TableCell align="right" sx={{ borderRight: '2px solid #000' }}>{item.correction_value.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</TableCell>
            </TableRow>
          ))}
          <TableRow>
            <TableCell colspan={5} sx={{ borderLeft: '2px solid #000', borderBottom: '2px solid #000' }}></TableCell>
            <TableCell align="right" sx={{ borderBottom: '2px solid #000', fontWeight: 'bold' }}>{currentContract.total_amortization.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</TableCell>
            <TableCell align="right" sx={{ borderBottom: '2px solid #000', fontWeight: 'bold', borderRight: '2px solid #000' }}>{currentContract.total_installment_value.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</TableCell>
            <TableCell align="right" sx={{ width: '5px', backgroundColor: "#ffffff" }}></TableCell>
            <TableCell align="right" sx={{ borderLeft: '2px solid #000', fontWeight: 'bold', borderBottom: '2px solid #000' }}>{currentContract.total_overpaid_value.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</TableCell>
            <TableCell align="right" sx={{ borderBottom: '2px solid #000' }}></TableCell>
            <TableCell align="right" sx={{ borderBottom: '2px solid #000', fontWeight: 'bold' }}>{currentContract.total_legal_interest.toFixed(2)}</TableCell>
            <TableCell colSpan={2} sx={{ borderBottom: '2px solid #000' }}></TableCell>
            <TableCell align="right" sx={{ borderBottom: '2px solid #000', fontWeight: 'bold', borderRight: '2px solid #000' }}>{currentContract.total_correction_value.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</TableCell>
          </TableRow>
        </TableBody>
      </Table>

      <Table size="small" sx={{ mt: 4 }}>
        <TableHead sx={{ backgroundColor: "#f0f0f0" }}>
          <TableRow>
            <TableCell sx={{ borderLeft: '2px solid #000', borderTop: '2px solid #000' }}></TableCell>
            <TableCell align="center" sx={{ fontWeight: "bold", borderTop: '2px solid #000' }}>CLASSIFICAÇÃO</TableCell>
            <TableCell align="right" sx={{ fontWeight: "bold", borderTop: '2px solid #000', borderRight: '2px solid #000' }}>VALORES</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow sx={{ height: 10 }}>
            <TableCell align="right" sx={{ borderLeft: '2px solid #000' }}>A</TableCell>
            <TableCell>CONTRATO ORIGINAL</TableCell>
            <TableCell align="right" sx={{ borderRight: '2px solid #000' }}>
              {(originalContractTotal).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
            </TableCell>
          </TableRow>
          <TableRow sx={{ height: 10 }}>
            <TableCell align="right" sx={{ borderLeft: '2px solid #000' }}>B</TableCell>
            <TableCell>CONTRATO JUROS DE MERCADO</TableCell>
            <TableCell align="right" sx={{ borderRight: '2px solid #000' }}>
              {interestMarketTotal.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
            </TableCell>
          </TableRow>
          <TableRow sx={{ height: 10 }}>
            <TableCell align="right" sx={{ borderLeft: '2px solid #000' }}>C</TableCell>
            <TableCell>COBRADO A MAIOR</TableCell>
            <TableCell align="right" sx={{ borderRight: '2px solid #000' }}>
              {overchargedAmountTotal.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
            </TableCell>
          </TableRow>
          <TableRow sx={{ height: 10 }}>
            <TableCell align="right" sx={{ borderLeft: '2px solid #000' }}>D</TableCell>
            <TableCell>PAGO ATÉ {moment(currentContract.updated_at).format("MM/YYYY")}</TableCell>
            <TableCell align="right" sx={{ borderRight: '2px solid #000' }} >
              {paidTotal.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
            </TableCell>
          </TableRow>
          <TableRow sx={{ height: 10 }}>
            <TableCell align="right" sx={{ borderLeft: '2px solid #000' }}>{captionCalcOverpaidAmountTotal}</TableCell>
            <TableCell sx={{ fontWeight: "bold", backgroundColor: "#f0f0f0" }}>{captionOverpaidAmoutTotal}</TableCell>
            <TableCell align="right" sx={{ fontWeight: "bold", backgroundColor: "#f0f0f0", borderRight: '2px solid #000' }}>{overpaidAmountTotal.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</TableCell>
          </TableRow>
          <TableRow sx={{ height: 10 }}>
            <TableCell align="right" sx={{ borderLeft: '2px solid #000' }}>F</TableCell>
            <TableCell>{captionLegalInterestToptal}</TableCell>
            <TableCell align="right" sx={{ borderRight: '2px solid #000' }} >{legalInterestTotal.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</TableCell>
          </TableRow>
          <TableRow sx={{ height: 10 }}>
            <TableCell align="right" sx={{ borderLeft: '2px solid #000' }}>G</TableCell>
            <TableCell>{captionIgpmTotal}</TableCell>
            <TableCell align="right" sx={{ borderRight: '2px solid #000' }} >-</TableCell>
          </TableRow>
          <TableRow sx={{ height: 10 }}>
            <TableCell align="right" sx={{ borderLeft: '2px solid #000', borderBottom: '2px solid #000' }}>{captionCalcReturnTotal}</TableCell>
            <TableCell sx={{ fontWeight: "bold", backgroundColor: "#f0f0f0", borderBottom: '2px solid #000' }}>{captionReturnTotal}</TableCell>
            <TableCell align="right" sx={{ fontWeight: "bold", backgroundColor: "#f0f0f0", borderBottom: '2px solid #000', borderRight: '2px solid #000' }} >{returnTotal.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </>
  );
};

export default ContractCalculations; 